import { useField } from "formik";
import { useIsCompleteInputClass } from './useIsCompleteInputClass'
import { useStyles } from "./useStyles";

const stylesNoLabelInput = theme => ({
  noInputLabel: {
    '& .MuiInputLabel-formControl': {
      transform: 'translate(0, 9px) scale(1)',
    },
    '& .MuiInputLabel-marginDense': {
      transform: 'translate(0, 7px) scale(1)',
    },
    '& .MuiInputLabel-outlined': {
      transform: 'translate(14px, 20px) scale(1)',

      '&.MuiInputLabel-marginDense': {
        transform: 'translate(14px, 12px) scale(1)',
      }
    },
    '& .MuiInputLabel-shrink': {
      visibility: 'hidden',
    },

    '& label + .MuiInput-formControl': {
      marginTop: 0
    }
    
  }
})
export const useFieldSmg = (name, variant) => {
  const [field, meta] = useField(name);
  const [isComplete, isCompleteClass] = useIsCompleteInputClass(field.value, meta.error, meta.touched);
  const classes = useStyles(stylesNoLabelInput);

  const hasError = meta.error && meta.touched

  const helperText = hasError ? meta.error : ' ';


  return {
    field,
    hasError,
    helperText,
    // InputProps,
    isComplete,
    isCompleteClass,
    noInputLabelClass: classes.noInputLabel,
  }
}